import api, { type ApiResponse } from "./api";

export type PaymentProvider = "stripe" | "razorpay";

export type SubscriptionResult = {
  paymentId: string;
  subscriptionId: string;
  status: "active" | "pending_payment";
  checkoutUrl: string | null;
  providerOrderId?: string | null;
  razorpayKeyId?: string | null;
  amountPaise?: number;
  currency?: string;
  provider?: PaymentProvider;
  publication?: {
    published: boolean;
    status: string;
  };
};

export async function initiateAppSubscription(
  applicationId: string,
  provider: PaymentProvider,
): Promise<SubscriptionResult> {
  const response = await api.post<ApiResponse<SubscriptionResult>>(
    `/apps/${applicationId}/subscriptions`,
    { provider },
  );
  return response.data.data;
}

export async function getPaymentStatus(paymentId: string): Promise<{
  id: string;
  status: string;
  application_id: string | null;
  lifecycleStatus?: string;
  renewalCompleted?: boolean;
  verificationComplete?: boolean;
}> {
  const response = await api.get<
    ApiResponse<{
      payment: {
        id: string;
        status: string;
        application_id: string | null;
        lifecycleStatus?: string;
        renewalCompleted?: boolean;
        verificationComplete?: boolean;
      };
    }>
  >(`/publisher/payments/${paymentId}/status`);
  return response.data.data.payment;
}

export async function verifyRazorpayAppPayment(input: {
  paymentId: string;
  orderId: string;
  razorpayPaymentId: string;
  signature: string;
}): Promise<{ verified: boolean; applied: boolean }> {
  const response = await api.post<
    ApiResponse<{ verification: { verified: boolean; applied: boolean } }>
  >("/payments/razorpay/verify", input);

  return response.data.data.verification;
}

export async function cancelPublisherPayment(paymentId: string): Promise<void> {
  await api.post(`/publisher/payments/${paymentId}/cancel`);
}
